import {user, firestore} from '@enigma/core/services';
import React, { useState, useEffect } from 'react';
import Button from '../../../../../../elements/Button/Button';
import { ico_bolt } from '../../../../../../icon';
import Loading from '../../../../../Spinner/Standard/Standard';
import Query from '../../../Query/Query';
import Stylesheet from './View.module.css';

const View = (props) => {
    let app = props.app;
    let table = props.table;
    let query = props.query;
    const [queries, setQueries] = useState(null);

    useEffect(() => {
        // attach listner to reports collection for table
        console.log(table)
        const listner = firestore
        .collection(`${table.metadata.document}/queries`)
        .orderBy('timestamp', 'asc')
        .onSnapshot(function (snap) {
            let collection = [];
            for (const record of snap.docs)
                collection.push({...record.data(), id: record.id});
            setQueries([...collection]);
        })
        return () => { listner() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const addNewQuery = _ => {
        // prepare new query request
        firestore.collection(
        `${table.metadata.document}/queries`)
        .add({
            isNew: true, // query is incomplete
            timestamp: Date.now(),
            author: user.displayName,
            branch: app.profile.branch
        })
        .then(_ => app.toggleToast(ico_bolt, 
            `new query created for ${table.metadata.name}`))
    }

    const getQueries = _ => {
        if (!queries) {
            return (
                <div className={Stylesheet.Loading}>
                    <Loading show={true} />
                </div>
            )
        }
        if (queries.length === 0) {
            return (
                <div className={Stylesheet.NoQueries}>
                    <h5>no queries for {table.metadata.name} yet, start by
                    clicking the 'Add New Query' button above.</h5>
                </div>
            )
        }
        return (
            queries.map((value, index) => (
                <Query 
                metadata={value} 
                key={index} 
                table={table} 
                app={app} 
                query={query} />
            ))
        )
    }

    return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Header}>
                <h4>Create and manage queries for {table.metadata.name}</h4>
                <h5>queries can be created to perform specific data 
                    searching and filtering, once a query
                    is created it will be visible to all verified 
                    users and can be executed at any time.
                    Note: queries will only execute on the current&nbsp;
                    <i>data range</i> selected for the table.
                </h5>
                <Button secondary onClick={addNewQuery}>add new query</Button>
            </div>
            <div className={Stylesheet.Queries}>
                {getQueries()}
            </div>
        </div>
    )
}

export default View;